module.exports = __webpack_public_path__ + "img/cafbd00.jpg";